<template>
  <div class="filter-bar">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FilterBar'
}
</script>
